import React from 'react';

import H2 from 'apps/Pdf/components/common/H2';

import { isoDateTimeToLabelZoned, formatNumber } from 'helpers/helpers';
import useTableStyles from 'apps/Pdf/styles/tables';
import useGeneralStyles from 'apps/Pdf/styles/general';
import { SecuritiesTransactionsData } from '../StatementInterface';
import { Currency } from 'enums';

interface Props {
  data: SecuritiesTransactionsData[];
  currency: Currency;
}

const translateType = (itemType?: 'PURCHASE' | 'SALE' | 'DEPOSIT' | 'WITHDRAWAL') => {
  switch (itemType) {
    case 'PURCHASE':
      return 'Nákup';
    case 'SALE':
      return 'Prodej';
    case 'DEPOSIT':
      return 'Vklad';
    case 'WITHDRAWAL':
      return 'Výběr';
  }
  return '';
};

const SecuritiesTransactionsTable = (props: Props) => {
  const styles = useGeneralStyles();
  const tables = useTableStyles();
  const { data } = props;

  return (
    <>
      {data.length ? (
        <>
          <H2>Transakce s cennými papíry</H2>
          <table className={`${tables.root} ${tables.overview} ${tables.transactions}`}>
            <thead>
              <tr>
                <th>&nbsp;</th>
                <th>Datum</th>
                <th>Typ</th>
                <th>Pokyn</th>
                <th>ISIN</th>
                <th>Nástroj</th>
                <th>Ks/Pozice</th>
                <th>Cena</th>
                <th>Hodnota</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item) => (
                <tr key={`item_${item.dateTime}`} className={styles.value}>
                  <td className="T1">&nbsp;</td>
                  <td>{isoDateTimeToLabelZoned(item.dateTime, 'd. M. yyyy HH:mm')}</td>
                  <td>{translateType(item.type)}</td>
                  <td>{item.instruction ? item.instruction : ''}</td>
                  <td>{item.isin}</td>
                  <td className={styles.left}>{item.instrument}</td>
                  <td>{formatNumber(item.position, 4)}</td>
                  <td>{formatNumber(item.price.value, 4)}</td>
                  <td>
                    {formatNumber(item.value.value, 2)}&nbsp;{item.value.currency}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      ) : null}
    </>
  );
};

export default SecuritiesTransactionsTable;
